import { useState } from 'react';

import { formatDate } from '../../config/chartTheme';
import type { TourismMeta } from '../../api/tourism';

/**
 * Herkunft und Grenzen der Zahlen. Gehört sichtbar auf die Seite, weil die
 * Zielgruppe die Daten weiterverwendet und wissen muss, was sie nicht hergeben.
 */
export default function DataBasisFootnote({ meta }: { meta: TourismMeta | undefined }) {
  const [open, setOpen] = useState(false);
  if (!meta) return null;

  return (
    <div className="text-xs text-gray-400 space-y-2">
      <p>
        Datenbasis: öffentlich zugängliche Angaben der Buchungsplattform, erhoben ab{' '}
        <span className="font-medium text-gray-500">{formatDate(meta.data_start)}</span>. Frühere
        Zeiträume sind nicht auswertbar. Letzte Erhebung:{' '}
        {formatDate(meta.last_scrape_at?.slice(0, 10))}.
      </p>
      <button onClick={() => setOpen(v => !v)} className="btn btn-text hover:underline">
        {open ? 'Methodik ausblenden' : 'Wie diese Zahlen entstehen'}
      </button>
      {open && (
        <div className="space-y-2 border-l-2 border-gray-100 pl-3 py-1">
          <p>
            <span className="font-medium text-gray-500">Belegung</span> ist der Anteil der nicht
            verfügbaren Tage an den Tagen, für die die Plattform überhaupt eine Angabe macht. Tage
            ohne Angabe zählen als unbekannt und gehen weder in Zähler noch Nenner ein.
          </p>
          <p>
            <span className="font-medium text-gray-500">Buchungs-Signale</span> sind Übergänge: ein
            Tag, der bei einer früheren Erhebung frei war und jetzt belegt ist. Aufeinanderfolgende
            solche Tage zählen als ein Signal. Das sind Indizien, keine bestätigten Buchungen — und
            sie setzen mindestens zwei Erhebungen desselben Inserats voraus.
          </p>
          <p>
            <span className="font-medium text-gray-500">Vergangenheit und Zukunft</span> sind nicht
            dasselbe. Links von heute steht, was beobachtet wurde; rechts davon, was die Plattform
            heute für später ausweist — keine Prognose. Ein belegter Tag in der Zukunft kann jederzeit
            wieder frei werden.
          </p>
          <p>
            <span className="font-medium text-gray-500">Nicht enthalten</span> sind ausgeblendete
            Inserate, erkannte Duplikate und Inserate außerhalb des Zuständigkeitsgebiets.
          </p>
        </div>
      )}
    </div>
  );
}
